var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1795 0.010498H0.820531C0.369219 0.010498 0 0.379717 0 0.830998V9.85665C0 10.3079 0.369219 10.6772 0.820531 10.6772H15.1795C15.6307 10.6772 16 10.308 16 9.85665V0.830998C16 0.379717 15.6308 0.010498 15.1795 0.010498ZM14.8716 0.625842L8.472 5.4259C8.35694 5.51347 8.18031 5.56825 7.99997 5.56744C7.81966 5.56825 7.64306 5.51347 7.52797 5.4259L1.12841 0.625842H14.8716ZM14.9403 10.0503L11.4531 5.74262C11.3462 5.61053 11.3665 5.41662 11.4988 5.30978C11.6307 5.2029 11.8246 5.22322 11.9315 5.35531L15.3845 9.6209V1.01047L8.84094 5.91815C8.59481 6.10153 8.29531 6.18215 7.99994 6.18278C7.70416 6.18197 7.40491 6.10134 7.15894 5.91815L0.615375 1.01047V9.62097L4.0685 5.35531C4.17537 5.22319 4.36903 5.20294 4.50112 5.30978C4.63347 5.41687 4.65372 5.61053 4.54688 5.74262L1.05969 10.0503C1.05774 10.0527 1.05555 10.0548 1.05335 10.0568C1.05159 10.0584 1.04983 10.06 1.04819 10.0618H14.9518C14.9503 10.0603 14.9488 10.0589 14.9472 10.0574C14.9448 10.0552 14.9424 10.0529 14.9403 10.0503Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEmail);
export default __webpack_public_path__ + "static/media/profile-email.76a2b78e.svg";
export { ForwardRef as ReactComponent };